










































import { Component, Vue, Emit, Prop } from "vue-property-decorator";
import { FeedImage } from "@/util/types";
import Moment from "moment";
import { CloudFunctionApis } from "@/services/cloudFunctionApis";
import BaseLoading from "@/components/BaseLoading.vue";

@Component({
  components: {
    BaseLoading
  }
})
export default class MediaItem extends Vue {
  @Prop(Object) readonly image!: FeedImage;
  @Prop(Number) readonly clientWidth!: number;

  api = new CloudFunctionApis();
  photoIsLiked = this.image.liked || false;
  isLoading: boolean = true;

  get createdAt() {
    const moment = Moment(this.image.created_at);
    if (moment.isBefore(Moment().subtract(365, "days"))) {
      return moment.format("MMM D, YYYY");
    } else if (moment.isBefore(Moment().subtract(26, "days"))) {
      return moment.format("MMM D");
    }
    return moment.fromNow();
  }

  get imageUrl() {
    return `${this.image.url}?w=600&auto=format&q=50&fm=jpg`;
  }

  get sizeStyle() {
    return `
      height: ${this.height}px;
      width: 100%;
    `;
  }

  get height() {
    let width = this.clientWidth;
    // for desktop, we limit the width to 480px
    if (width > 480) {
      width = 480;
    }

    // desired width divided by aspect ratios = desired height
    return Math.floor(width / this.aspectRatio);
  }

  get aspectRatio() {
    return this.image.image_width / this.image.image_height;
  }

  get photoIsLikedByUser() {
    return this.photoIsLiked;
  }

  get likeCount() {
    const isLikedCount = this.photoIsLikedByUser ? 1 : 0;
    return this.image.likes + isLikedCount;
  }

  get latLng() {
    return {
      lat: this.image.latitude,
      lng: this.image.longitude
    };
  }

  get gMapsLink() {
    const baseUrl = "https://www.google.com/maps/search/?api=1&query=";
    return `${baseUrl}${this.latLng.lat},${this.latLng.lng}`;
  }

  onImageLoaded() {
    this.isLoading = false;
  }

  async clickLikeIcon() {
    this.photoIsLiked = !this.photoIsLiked;

    // TODO: add some delay so we don't spam the API if someone rapidly clicks "like/unlike"
    if (this.photoIsLiked) {
      await this.api.likePhoto(this.image.id);
    } else {
      await this.api.unlikePhoto(this.image.id);
    }
  }
}
